import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function Search() {
  const [query, setQuery] = useState('');

  const results = query.trim()
    ? featuredComics.filter(
        (c) =>
          c.title.includes(query) ||
          c.author.includes(query) ||
          c.category.includes(query)
      )
    : [];

  return (
    <>
      <Navbar />
      <PageSEO
        type="search"
        query={query.trim() || undefined}
        resultCount={results.length}
        breadcrumbItems={[{ label: '首页', to: '/' }, { label: '搜索' }]}
      />
      <main className="pt-20 md:pt-24 min-h-screen bg-background-50">
        <div className="px-4 md:px-6 max-w-7xl mx-auto py-10">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 font-medium">搜索</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-8">
            搜索<span className="text-accent-500">漫画</span>
          </h1>

          {/* Search input */}
          <div className="max-w-xl mb-10">
            <div className="relative">
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="输入漫画名称、作者或分类..."
                className="w-full pl-12 pr-4 py-3.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-100 transition-all"
              />
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            </div>
          </div>

          {/* Results */}
          {query.trim() && (
            <div>
              <p className="text-sm text-foreground-500 mb-6">
                找到 <strong className="text-foreground-900">{results.length}</strong> 个相关结果
              </p>
              {results.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
                  {results.map((comic) => (
                    <Link
                      key={comic.id}
                      to={`/comic/${comic.id}`}
                      className="group cursor-pointer"
                    >
                      <div className="aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                        <img
                          src={comic.cover}
                          alt={comic.title}
                          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {comic.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1">{comic.author} · {comic.category}</p>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto bg-background-100 rounded-2xl flex items-center justify-center mb-4">
                    <i className="ri-search-line text-foreground-300 text-2xl"></i>
                  </div>
                  <p className="text-foreground-500">未找到相关漫画，试试其他关键词吧</p>
                </div>
              )}
            </div>
          )}

          {/* Popular searches when empty */}
          {!query.trim() && (
            <div>
              <h2 className="text-lg font-semibold text-foreground-900 mb-4">热门搜索</h2>
              <div className="flex flex-wrap gap-2">
                {['武侠', '言情', '玄幻', '古风', '龙', '猫妖', '桃花'].map((tag) => (
                  <button
                    key={tag}
                    onClick={() => setQuery(tag)}
                    className="px-4 py-2 bg-background-100 hover:bg-accent-50 text-sm text-foreground-600 hover:text-accent-600 rounded-full transition-all cursor-pointer"
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}